import React, {useCallback, useContext} from 'react';
import {AutoField} from 'components/forms/fields';
import Section from 'components/forms/Section';
import {Button, FormHelperText, Typography} from '@material-ui/core';
import fields from './fields';
import {Link} from 'react-router-dom';
import {useClearForm, useFieldData} from 'components/forms/hooks';
import {FormState} from 'components/forms/context';
import {bootstrapOldForm} from '../AutoSection';

const Signature = ({...props}) => {
    const {schema, initialValues} = bootstrapOldForm('Signature', fields);

    const [signed, setSigned] = useFieldData('document_signed');
    const [officialLetterhead, setOfficialLetterhead] = useFieldData(
        'official_letterhead'
    );
    const {node} = useContext(FormState);
    const clearForm = useClearForm(node);
    const onAbortClick = useCallback(() => {
        clearForm();
    }, [clearForm]);

    const showWarning =
        signed === false ||
        signed === 'false' ||
        officialLetterhead === false ||
        officialLetterhead === 'false';

    const updateOfficialLetterhead = event => {
        setOfficialLetterhead(event.target.value === 'true');
    };
    const updateSigned = event => {
        setSigned(event.target.value === 'true');
    };

    return (
        <Section {...props} schema={schema} initialValues={initialValues}>
            <Typography variant='h6' align='left'>
                Signature
            </Typography>
            <AutoField field={fields.ssl_type} name='ssl_type' />
            <AutoField
                field={fields.official_letterhead}
                name='official_letterhead'
                onChange={updateOfficialLetterhead}
            />
            <AutoField
                field={fields.document_signed}
                name='document_signed'
                onChange={updateSigned}
            />
            <AutoField
                field={fields.date_document_signed}
                name='date_document_signed'
            />
            {showWarning && (
                <div>
                    <FormHelperText error>
                        The MM-SEAS system only accepts signed paperwork. You
                        will not be able to submit an unsigned document. You
                        will need to start again and upload a new photo once
                        your document is signed. You may continue to enter data
                        to check for other errors, or click the button below to
                        exit without saving.
                    </FormHelperText>
                    <p></p>
                    <Button
                        component={Link}
                        to='/seaservice'
                        variant='contained'
                        color='secondary'
                        onClick={onAbortClick}
                    >
                        Discard and Exit
                    </Button>
                </div>
            )}
            {props.children}
        </Section>
    );
};

export default Signature;
